import { Component, OnChanges, Input } from "@angular/core";

import { AssemblyConfig, APIResults } from "src/app/sharedinterfaces";
import { ApiService } from "src/app/api.service";
import { ChartingService } from "src/app/charting.service";

@Component({
	selector: "app-impact-detail",
	templateUrl: "./impact-detail.component.html",
	styleUrls: ["./impact-detail.component.scss"]
})
export class ImpactDetailComponent implements OnChanges {
	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	component: AssemblyConfig.Impact;
	@Input()
	raw: APIResults.RawSinglesResult;

	public spectrumxoptions?: Highcharts.Options;
	public spectrumyoptions?: Highcharts.Options;
	public spectrumzoptions?: Highcharts.Options;
	public errormessage: string;

	constructor(private api: ApiService, private charting: ChartingService) {
	}

	async ngOnChanges() {
		if (this.asset && this.component && this.raw) {
			this.spectrumxoptions = undefined;
			this.spectrumyoptions = undefined;
			this.spectrumzoptions = undefined;
			this.errormessage = null;
			try {
				const result = await this.api.GetImpactDetail(this.asset.asset_id, this.component.id, this.raw.rawid);
				this.spectrumxoptions = this.charting.ImpactDefaults("Vertical", "Gs", [
					{ type: "line", name: "Spectrum Analysis", data: result.spectrumx },
				]);
				this.spectrumyoptions = this.charting.ImpactDefaults("Tangential", "Gs", [
					{ type: "line", name: "Spectrum Analysis", data: result.spectrumy },
				]);
				this.spectrumzoptions = this.charting.ImpactDefaults("Radial", "Gs", [
					{ type: "line", name: "Spectrum Analysis", data: result.spectrumz },
				]);
			} catch (err) {
				this.errormessage = "Unable to load impact details";
				console.error("Couldn't load impact details");
				console.log(err);
			}
		}
	}
}
